import { useEffect, useState } from 'react';
import { getStuckLevel } from './types';
import type { StuckLevel } from './types';

interface StuckIndicatorProps {
  lastActivityAt: string;
}

const LEVEL_STYLES: Record<StuckLevel, string> = {
  ok: 'text-green-400',
  warning: 'text-yellow-400',
  critical: 'text-red-400',
};

const LEVEL_ICONS: Record<StuckLevel, string> = {
  ok: '\u2705',
  warning: '\u26a0',
  critical: '\u274c',
};

function formatElapsed(ms: number): string {
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h`;
}

export function StuckIndicator({ lastActivityAt }: StuckIndicatorProps) {
  const [elapsed, setElapsed] = useState(() => Date.now() - new Date(lastActivityAt).getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed(Date.now() - new Date(lastActivityAt).getTime());
    }, 1000);
    return () => clearInterval(interval);
  }, [lastActivityAt]);

  const level = getStuckLevel(elapsed);

  return (
    <span data-testid="stuck-indicator" className={`inline-flex items-center gap-1 ${LEVEL_STYLES[level]}`}>
      <span>{LEVEL_ICONS[level]}</span>
      {level !== 'ok' && <span>{formatElapsed(elapsed)}</span>}
    </span>
  );
}
